import { ItemListSectionHeaderRowData } from "@/components/item-list/types";
import { MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import { StyledWrapper, StyledPrimaryText } from "./item-list-section-header-row.style";

interface Props {
  data: ItemListSectionHeaderRowData;
}

export const ItemListSectionHeaderRow = ({ data }: Props) => {
  const { title } = data.payload;

  return (
    <StyledWrapper key={title}>
      <StyledPrimaryText
        color={MDSTextColor.Secondary}
        variant={MDSTextVariant.TextXs}
        weight={MDSTextWeight.SemiBold}
      >
        {title}
      </StyledPrimaryText>
    </StyledWrapper>
  );
};
